import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';
import { IconMapHighway16 } from '@cian/ui-kit-design-tokens/icons';
import * as style from './style.css';

interface IRoadItemProps {
  name: string;
  distance: string;
}

export const RoadItem: React.FC<IRoadItemProps> = ({ name, distance }) => {
  return (
    <div className={style['item']}>
      <div className={style['highway-icon']}>
        <IconMapHighway16 color="icon-secondary-default" />
      </div>

      <UIText2>{name}</UIText2>
      <UIText2 color="text-secondary-default">
        {' '}
        {distance}
      </UIText2>
    </div>
  );
};
